import axios from 'axios'
import {
  ACCOUNTS_INSIGHTS_AGE,
  ACCOUNTS_INSIGHTS_LOADING,
  ACCOUNTS_INSIGHTS_NATIONALITY,
  ACCOUNTS_INSIGHTS_SIZE,
  ACCOUNTS_INSIGHTS_TYPE,
  CLEAR_ACCOUNTS_INSIGHTS,
  GET_ACCOUNTS_INSIGHTS_CONTACTS,
} from './accountsInsightsTypes'

const setLoading = (isLoading) => (dispatch) => {
  dispatch({ type: ACCOUNTS_INSIGHTS_LOADING, payload: isLoading })
}

const getNationalityChartData = (filters) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get('/accounts-insights/nationalities', { params: { filters } })
    dispatch({ type: ACCOUNTS_INSIGHTS_NATIONALITY, payload: res.data })
  } finally {
    dispatch(setLoading(false))
  }
}

const getCompanyTypeChartData = (filters) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get('/accounts-insights/company-types', { params: { filters } })
    dispatch({ type: ACCOUNTS_INSIGHTS_TYPE, payload: res.data })
  } finally {
    dispatch(setLoading(false))
  }
}

const getCompanySizeChartData = (filters) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get('/accounts-insights/company-sizes', { params: { filters } })
    dispatch({ type: ACCOUNTS_INSIGHTS_SIZE, payload: res.data })
  } finally {
    dispatch(setLoading(false))
  }
}

const getCompanyAgeChartData = (filters) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get('/accounts-insights/company-ages', { params: { filters } })
    dispatch({ type: ACCOUNTS_INSIGHTS_AGE, payload: res.data })
  } finally {
    dispatch(setLoading(false))
  }
}

export const getChartData = (type, filters) => async (dispatch) => {
  switch (type) {
    case 'nationality':
      dispatch(getNationalityChartData(filters))
      break
    case 'size':
      dispatch(getCompanySizeChartData(filters))
      break
    case 'type':
      dispatch(getCompanyTypeChartData(filters))
      break
    case 'age':
      dispatch(getCompanyAgeChartData(filters))
      break
    default:
      break
  }
}

export const getAllChartsData = (filters) => async (dispatch) => {
  dispatch(getNationalityChartData(filters))
  setTimeout(() => {
    dispatch(getCompanySizeChartData(filters))
  }, 1000)

  setTimeout(() => {
    dispatch(getCompanyTypeChartData(filters))
  }, 2000)

  setTimeout(() => {
    dispatch(getCompanyAgeChartData(filters))
  }, 3000)
}

export const getContacts = (options) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get('accounts-insights/contacts', {
      params: {
        ...options,
      },
    })

    dispatch({ type: GET_ACCOUNTS_INSIGHTS_CONTACTS, payload: res.data })
  } finally {
    dispatch(setLoading(false))
  }
}

export const clearAccountsInsights = () => (dispatch) => {
  dispatch({ type: CLEAR_ACCOUNTS_INSIGHTS })
}
